import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconOverflowSvg } from "./IconOverflowSvg.mjs";
const IconOverflow = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconOverflowSvg, ...svgProps }) });
export {
  IconOverflow
};
